export const homeFaqs = [
  {
    id: 1,
    question: "Who provides AC repair near me in Dallas?",
    answer:
      "KISA Cooling Dallas provides professional AC repair services across Dallas and surrounding areas including Plano, Irving, Garland, Richardson, and Mesquite. Our team handles diagnostics, repairs, and system optimization to restore cooling performance quickly and efficiently, especially during high-demand summer conditions.",
  },
  {
    id: 2,
    question: "How much does AC repair cost in Dallas?",
    answer:
      "AC repair costs in Dallas vary depending on the issue, system type, and parts required. Minor repairs such as capacitor or thermostat replacements are typically lower cost, while major component replacements such as compressors or full system overhauls increase pricing. A professional inspection is the best way to determine accurate costs. Contact us for a no-obligation quote.",
  },
  {
    id: 3,
    question: "How long does AC installation take?",
    answer:
      "Most AC installations can be completed within a single day, depending on the system complexity and property setup. Larger or more customized systems may take longer to ensure proper installation and performance optimization. Our team works efficiently to minimize disruption to your home or business.",
  },
  {
    id: 4,
    question: "Do you offer emergency HVAC service in Dallas?",
    answer:
      "Yes, KISA Cooling Dallas offers emergency HVAC service for urgent situations. We understand that cooling failures in Texas heat can be dangerous, and our team prioritizes emergency calls to restore your comfort as quickly as possible. Call us at 214-870-3185 for immediate assistance.",
  },
  {
    id: 5,
    question: "What HVAC brands do you service?",
    answer:
      "Our technicians are trained to service and repair all major HVAC brands including Carrier, Trane, Lennox, Rheem, Goodman, York, Bryant, and more. Whether your system is residential or commercial, we have the expertise to diagnose and resolve the issue.",
  },
  {
    id: 6,
    question: "How often should I schedule AC maintenance?",
    answer:
      "We recommend scheduling preventative AC maintenance at least once per year, ideally in the spring before peak summer heat arrives. Regular maintenance extends system lifespan, improves efficiency, reduces energy costs, and catches minor issues before they become major failures.",
  },
];

export const serviceFaqs = [
  {
    id: 1,
    question: "How quickly can AC be repaired?",
    answer:
      "Most AC repairs can be completed the same day depending on the issue and part availability. Emergency situations are prioritized to restore cooling as quickly as possible. Our technicians carry commonly needed parts to minimize wait times.",
  },
  {
    id: 2,
    question: "What are signs my AC needs repair?",
    answer:
      "Common signs include warm air blowing from vents, reduced airflow, unusual noises, frequent cycling on and off, high humidity indoors, strange odors, and unexplained spikes in energy bills. If you notice any of these, contact us for a diagnostic assessment.",
  },
  {
    id: 3,
    question: "Can AC repair be avoided with regular maintenance?",
    answer:
      "Regular maintenance significantly reduces the likelihood of unexpected breakdowns. During maintenance visits, technicians identify and address minor issues before they escalate, clean components for better efficiency, and optimize system performance — saving you money in the long run.",
  },
  {
    id: 4,
    question: "Is it better to repair or replace my AC unit?",
    answer:
      "This depends on the age of your system, the cost of repairs, and system efficiency. Generally, if repair costs exceed 50% of replacement cost or the system is over 10 years old and experiencing frequent issues, replacement is often the better long-term investment. Our technicians provide honest recommendations.",
  },
];

export const aboutFaqs = [
  {
    id: 1,
    question: "Why choose a professional HVAC company?",
    answer:
      "Professional HVAC companies ensure systems are installed and repaired correctly, improving efficiency, reducing long-term costs, and preventing breakdowns during high-demand seasons. Licensed technicians have the training and tools to handle refrigerant safely, diagnose complex issues, and ensure your system operates at peak performance.",
  },
  {
    id: 2,
    question: "Is KISA Cooling Dallas licensed and insured?",
    answer:
      "Yes, KISA Cooling Dallas is fully licensed and insured. Our technicians hold the required state certifications to perform HVAC work in Texas, and we carry full liability insurance for all residential and commercial projects.",
  },
  {
    id: 3,
    question: "What areas does KISA Cooling Dallas serve?",
    answer:
      "We serve Dallas and surrounding communities including Plano, Irving, Garland, Richardson, Mesquite, McKinney, and other nearby areas. Contact us to confirm service availability in your specific location.",
  },
];

export const locationFaqs = [
  {
    id: 1,
    question: "Do you provide AC services in Dallas?",
    answer:
      "Yes, KISA Cooling Dallas provides air conditioning repair, installation, and maintenance services throughout Dallas, ensuring reliable cooling performance for residential and commercial properties. We serve all Dallas neighborhoods and surrounding communities.",
  },
  {
    id: 2,
    question: "How fast can you respond to service calls in Dallas?",
    answer:
      "We aim to provide same-day service for most calls in the Dallas area. For emergency situations, we prioritize rapid response to ensure your cooling is restored as quickly as possible. Call 214-870-3185 to schedule service.",
  },
  {
    id: 3,
    question: "Do you service both homes and businesses in Dallas?",
    answer:
      "Yes, KISA Cooling Dallas provides HVAC services for both residential and commercial properties throughout Dallas. Our technicians are trained on a full range of system types and sizes to meet the needs of any property.",
  },
];